<template>
  <div class="wrapper-page">
    <noscript><img height="1" width="1" style="display:none"
src="https://www.facebook.com/tr?id=2696293753940191&ev=PageView&noscript=1"
/></noscript>
    <div class="popup-container" ref="popupbg" v-if="isShowPopup">
      <div class="popup-content">
        <div class="close-container">
          <span class="close" @click="closePopup()">&times;</span>
        </div>
        <form class="gform pure-form pure-form-stacked" method="POST" data-email="info.grandsteels@gmail.com"
          id="form_contact"
          @submit.prevent="onSubmit2(firstname, lastname, tel, email, selectProduct, description)"
          >
        <!-- <form ref="form" class="gform pure-form pure-form-stacked needs-validation" method="POST" data-email="example@email.net"
          action="https://script.google.com/macros/s/AKfycbzzH27YkbOrgc_TAjYBMbldqd3lbggXxCKoyeqUU2REwBlfATw/exec"> -->
          <!-- change the form action to your script url -->

          <div class="form-elements">
            <fieldset class="form-group pure-group">
              <input
                class="form-control"
                type="text"
                v-model="firstname"
                id="firstname"
                name="firstname"
                placeholder="ชื่อ"
                required
              />
            </fieldset>
            <fieldset class="form-group pure-group">
              <input
                class="form-control"
                type="text"
                v-model="lastname"
                id="lastname"
                name="lastname"
                placeholder="นามสกุล"
                required
              />
            </fieldset>
            <fieldset class="form-group pure-group">
              <input
                class="form-control"
                type="tel"
                v-model="tel"
                placeholder="เบอร์โทรศัพท์"
                id="tel"
                name="tel"
                pattern="[0-9]{3}[0-9]{3}[0-9]{4}"
                required
              />
            </fieldset>
            <fieldset class="form-group pure-group">
              <input
                class="form-control"
                type="email"
                v-model="email"
                id="email"
                value=""
                name="email"
                placeholder="อีเมล"
                required
              />
            </fieldset>
            <fieldset class="form-group pure-group">
              <input
                class="form-control input-readonly"
                id="product"
                name="product"
                placeholder="สินค้าที่สนใจ"
                :value="this.selectProduct"
                readonly
                required
              />
              <select
                class="form-control"
                @change="formSelectProduct"
                required
              >
                <option selected disabled>--กรุณาเลือกสินค้าที่สนใจ--</option>
                <option
                  v-for="(intro, index) in getAllIntro"
                  :key="index"
                  :value="intro.name">
                  {{intro.name}}
                </option>
              </select>
            </fieldset>
            <fieldset class="form-group">
              <textarea
                class="form-control"
                type="text"
                v-model="description"
                id="description"
                name="description"
                placeholder="ข้อความ"
                style="margin"
              />
            </fieldset>

            <fieldset class="pure-group honeypot-field" style="display: none;">
              <label for="honeypot">To help avoid spam, utilize a Honeypot technique with a hidden text field; must be empty to submit the form! Otherwise, we assume the user is a spam bot.</label>
              <input id="honeypot" type="text" name="honeypot" value="" />
            </fieldset>

            <button class="btn button-success pure-button button-xlarge">
              <i class="fa fa-paper-plane"></i>&nbsp;ส่งข้อมูล</button>
          </div>

          <!-- Customise the Thankyou Message People See when they submit the form: -->
          <div class="thankyou_message" style="display:none;">
            <h2><em>Thanks</em> for contacting us!
              We will get back to you soon!</h2>
          </div>

        </form>
      </div>
    </div>
    <div class="wrapper-bg-header bg-header" v-if="product && product.name">
      <div class="container banner-text">
        <h1 v-if="product && product.name">{{product.name}}</h1>
      </div>
    </div>
    <div>
      <div class="container content-container-max-width">
        <div class="intro-container">
          <vue-previewer class="vue-previewer-container " :images="images" :options="{}"/>
          <div>
            <h1 v-if="product && product.name">{{product.name}}</h1>
            <p class="pre-line" v-if="product && product.description">{{product.description}}</p>
            <div class="btn-container column-when-450">
              <a :href="messagerlink" target="_blank">
                <button class="btn-darkblue">สอบถามราคา</button>
              </a>
              <a>
                <button class="btn-darkblue" @click="openPopup()">ลงทะเบียนสอบถามราคา</button>
              </a>
              <a :href="pdfPath" target="_blank" v-if="pdfPath">
                <button class="btn-darkblue">ดาวโหลดคุณสมบัติ</button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        class="container content-container-max-width row-center"
        v-for="t of product.tables"
        :key="t.key"
      >
        <h3 v-if="t.title">{{t.title}}</h3>
        <img v-if="t.image" class="img-profile" :src="`/img/${t.image}`">
        <p class="pre-line" v-if="t && t.description">{{t.description}}</p>
        <div v-if="t.table" v-html="t.table"></div>
      </div>
    </div>
  </div>
</template>

<script>
import data from "@/services/data.js";
import { mapGetters } from "vuex";
import service from "@/services/service.js";
import { ALLINTRO } from "@/store/actions.type";

export default {
  name: "Product",
  data: function() {
    return {
      isShowPopup: false,
      firstname: null,
      lastname: null,
      tel: null,
      email: null,
      selectProduct: "",
      description: null
    }
  },
  mounted() {
//     this.isShowPopup = localStorage.getItem('isShowPopup') === "true" ? true : false;
//     if ( !gapi || !gapi.auth2 || !gapi.auth2.getAuthInstance() || !gapi.auth2.getAuthInstance().isSignedIn || !gapi.auth2.getAuthInstance().isSignedIn.get() ) {
//       this.closePopup();
//     } else {
//       // pixel
//       !function(f,b,e,v,n,t,s)
// {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
// n.callMethod.apply(n,arguments):n.queue.push(arguments)};
// if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
// n.queue=[];t=b.createElement(e);t.async=!0;
// t.src=v;s=b.getElementsByTagName(e)[0];
// s.parentNode.insertBefore(t,s)}(window, document,'script',
// 'https://connect.facebook.net/en_US/fbevents.js');
// fbq('init', '2696293753940191');
// fbq('track', 'LoginView');
//     }

    if (gapi && gapi.auth2 && gapi.auth2.getAuthInstance() && gapi.auth2.getAuthInstance().isSignedIn && gapi.auth2.getAuthInstance().isSignedIn.get()) {
      
    } else {
      this.closePopup();
    }
    if ( localStorage.getItem('isShowPopup') === "true" ) {
      this.isShowPopup = true;
    }

    this.handleClientLoad()
    window.onclick = (event) => {
      if (event.target == this.$refs.popupbg) {
        this.closePopup()
      }
    }
  },
  computed: {
    ...mapGetters(["getAllIntro"]),
    messagerlink() {
      return data.link.facebook;
    },  
    images() {
      if (this.product && this.product.images && this.product.images.length) {
        const _list = [];
        for (const i in this.product.images) {
          if (this.product.images[i]) {
            _list.push(`/img/${this.product.images[i]}`);
          }
        }
        return _list;
      }
      return [];
    },
    currentProduct() {
      const currentNameRoute = this.$route.params.product;
      return this.getAllIntro.find(p => p.name === currentNameRoute);
    },
    pdfPath() {
      return this.product.name && this.product.name && this.product.name.indexOf("เหล็ก") === 0 ? `/pdf/${this.product.name}.pdf` : false
    },
    isLogin() {
      if (gapi.auth2 && gapi.auth2.getAuthInstance().isSignedIn.get() === true) {
        return true
      }
      return false
    },
    isLoginFail() {
      return !gapi || !gapi.auth2 || !gapi.auth2.getAuthInstance() || !gapi.auth2.getAuthInstance().isSignedIn || !gapi.auth2.getAuthInstance().isSignedIn.get()
    }
  },
  methods: {
    handleClientLoad() {
      gapi.load("client:auth2", this.initClient);
    },
    initClient() {
      //provide the authentication credentials you set up in the Google developer console
      const CLIENT_ID =
        "1073886515332-dss5a2pjgmp3lh2ovduvvg74nka5to8e.apps.googleusercontent.com"; //from https://console.developers.google.com/apis/credentials
      const API_KEY = "AIzaSyBNnTUnyHWRJLOilb3KryOfqWCLXxqKjR4"; //https://console.developers.google.com/apis/credentials
      const SCOPE = "https://www.googleapis.com/auth/spreadsheets";
      const REDIRECT_URL = window.location.origin + "/" + encodeURI(this.$route.params.product);
      gapi.client
        .init({
          apiKey: API_KEY,
          clientId: CLIENT_ID,
          scope: SCOPE,
          ux_mode: "redirect",
          redirect_uri: REDIRECT_URL,
          discoveryDocs: [
            "https://sheets.googleapis.com/$discovery/rest?version=v4"
          ]
        })
        .then((response) => {
          // console.log(
          //   "isSignedIn :",
          //   gapi.auth2.getAuthInstance().isSignedIn.get()
          // );
          if ( !gapi || !gapi.auth2 || !gapi.auth2.getAuthInstance() || !gapi.auth2.getAuthInstance().isSignedIn || !gapi.auth2.getAuthInstance().isSignedIn.get() ) {
            this.closePopup();
            // console.log("gapi.auth2.getAuthInstance().isSignedIn.get() == true");
            // gapi.auth2.getAuthInstance().signIn();
            // console.log("response :", response);
          // } else {
          //   localStorage.setItem('isShowPopup', false);
          //   this.isShowPopup = false;
          }
          // if (gapi.auth2.getAuthInstance().isSignedIn.get() == false) {
            // console.log("gapi.auth2.getAuthInstance().isSignedIn.get() == false");
            // gapi.auth2.getAuthInstance().signIn();
            // console.log("response :", response);
          // }
          // gapi.auth2.getAuthInstance().isSignedIn.listen(this.updateSignInStatus); //add a function called `updateSignInStatus` if you want to do something once a user is logged in with Google
          // this.updateSignInStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
        });
    },
    handleClientLoad_autologin() {
      gapi.load("client:auth2", this.initClient_autologin);
    },
    initClient_autologin() {
      //provide the authentication credentials you set up in the Google developer console
      const CLIENT_ID =
        "1073886515332-dss5a2pjgmp3lh2ovduvvg74nka5to8e.apps.googleusercontent.com"; //from https://console.developers.google.com/apis/credentials
      const API_KEY = "AIzaSyBNnTUnyHWRJLOilb3KryOfqWCLXxqKjR4"; //https://console.developers.google.com/apis/credentials
      const SCOPE = "https://www.googleapis.com/auth/spreadsheets";
      const REDIRECT_URL = window.location.origin + "/" + encodeURI(this.$route.params.product);
      gapi.client
        .init({
          apiKey: API_KEY,
          clientId: CLIENT_ID,
          scope: SCOPE,
          ux_mode: "redirect",
          redirect_uri: REDIRECT_URL,
          discoveryDocs: [
            "https://sheets.googleapis.com/$discovery/rest?version=v4"
          ]
        })
        .then((response) => {
          localStorage.setItem('isShowPopup', true);
          this.isShowPopup = true;
          gapi.auth2.getAuthInstance().signIn();
        });
    },
    openPopup() {
      // if ( !gapi || !gapi.auth2 || !gapi.auth2.getAuthInstance() || !gapi.auth2.getAuthInstance().isSignedIn || !gapi.auth2.getAuthInstance().isSignedIn.get() ) {

      //   // this.handleClientLoad_autologin();
      //   // gapi.auth2.getAuthInstance().signIn();
      // } else {
        localStorage.setItem('isShowPopup', true);
        this.isShowPopup = true;
      // }
    },
    formSelectProduct (e) {
      if (e.target && e.target.value) {
        if (this.selectProduct.length > 0) {
          this.selectProduct = this.selectProduct+", "+e.target.value
        } else {
          this.selectProduct = this.selectProduct+e.target.value
        }
      }
    },
    closePopup() {
      localStorage.setItem('isShowPopup', false);
      this.isShowPopup = false;
    },
    onSubmit2(firstname, lastname, tel, email, selectProduct, description) {
      var form = document.getElementById("form_contact");
      // var form = event.target;
      var formData = this.getFormData(form);
      var data = formData.data;

      // If a honeypot field is filled, assume it was done so by a spam bot.
      if (formData.honeypot) {
        return false;
      }

      // disableAllButtons(form);
      // var url = form.action
      var url = "https://script.google.com/macros/s/AKfycbzzH27YkbOrgc_TAjYBMbldqd3lbggXxCKoyeqUU2REwBlfATw/exec";
      var xhr = new XMLHttpRequest();
      var previousLink = "";
      previousLink += window.location.href;
      xhr.open('POST', url);
      // xhr.withCredentials = true;
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.onreadystatechange = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            form.reset();

        // pixel
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '2696293753940191');
        fbq('track', 'LoginView');

        this.closePopup();

        window.alert("ข้อมูลได้ถูกจัดส่งเรียบร้อย")
            
          }
      };
      // url encode form data for sending as post data
      var encoded = Object.keys(data).map(function(k) {
          return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
      }).join('&');
      xhr.send(encoded);
    },
    getFormData (form) {
      var elements = form.elements;
      var honeypot;

      var fields = Object.keys(elements).filter(function(k) {
        if (elements[k].name === "honeypot") {
          honeypot = elements[k].value;
          return false;
        }
        return true;
      }).map(function(k) {
        if(elements[k].name !== undefined) {
          return elements[k].name;
        // special case for Edge's html collection
        }else if(elements[k].length > 0){
          return elements[k].item(0).name;
        }
      }).filter(function(item, pos, self) {
        return self.indexOf(item) == pos && item;
      });

      var formData = {};
      fields.forEach(function(name){
        var element = elements[name];
        
        // singular form elements just have one value
        formData[name] = element.value;

        // when our element has multiple items, get their values
        if (element.length) {
          var data = [];
          for (var i = 0; i < element.length; i++) {
            var item = element.item(i);
            if (item.checked || item.selected) {
              data.push(item.value);
            }
          }
          formData[name] = data.join(', ');
        }
      });

      // add form-specific values into the data
      formData.formDataNameOrder = JSON.stringify(fields);
      formData.formGoogleSheetName = form.dataset.sheet || "responses"; // default sheet name
      formData.formGoogleSendEmail
        = form.dataset.email || ""; // no email by default

      return {data: formData, honeypot: honeypot};
    },
    async onSubmit(firstname, lastname, tel, email, selectProduct, description) {
      await gapi.load("client:auth2", this.initClient);
      
      // if isn't signin, let signin google acccount
      if (!gapi || !gapi.auth2 || !gapi.auth2.getAuthInstance() || !gapi.auth2.getAuthInstance().isSignedIn || !gapi.auth2.getAuthInstance().isSignedIn.get()) {
        gapi.auth2.getAuthInstance().signIn();
      }
      const SPREADSHEET_ID = "1k6UXhd0Ahx77uHGUA4vGUmHBTQ5C0mwYQwQWtXeWQuY"; //from the URL of your blank Google Sheet
      let data = [[firstname], [lastname], [tel], [email], [selectProduct], [description]];
      // console.log("data : ", data);

      const params = {
        spreadsheetId: SPREADSHEET_ID,
        range: "form", //this is the default spreadsheet name, so unless you've changed it, or are submitting to multiple sheets, you can leave this
        valueInputOption: "RAW", //RAW = if no conversion or formatting of submitted data is needed. Otherwise USER_ENTERED
        insertDataOption: "INSERT_ROWS" //Choose OVERWRITE OR INSERT_ROWS
      };

      const valueRangeBody = {
        majorDimension: "COLUMNS", //log each entry as a new row (vs column)
        values: data //convert the object's values to an array
      };

      let request = gapi.client.sheets.spreadsheets.values.append(
        params,
        valueRangeBody
      );
      request.then(
        (response) => {
          // TODO: Insert desired response behaviour on submission
          // console.log(response.result);
          this.$refs.form.reset();
          this.firstname = "";
          this.lastname = "";
          this.tel = "";
          this.email = "";
          this.selectProduct = "";
          this.description = "";
          this.isShowPopup = false;
          localStorage.setItem('isShowPopup', 'false');
        },
        (response) => {
          // console.error("error: " + reason.result.error.message);
          this.$refs.form.reset();
          this.firstname = "";
          this.lastname = "";
          this.tel = "";
          this.email = "";
          this.selectProduct = "";
          this.description = "";
          this.isShowPopup = false;
          localStorage.setItem('isShowPopup', 'false');
        }
      );
    }
  },
  asyncComputed: {
    async product() {
      if (this.currentProduct) {
        const startindex = this.currentProduct.startindex;
        if (this.currentProduct && startindex) {
          const endindex = "Z" + startindex.slice(1);
          const resultValues = (await service.getDataByRange(`products!${startindex}:${endindex}`)).data;
          if (resultValues && resultValues.values && resultValues.values.length > 0) {
            return await service.getExtractValues_2(resultValues.values[0]);
          }
        }
      }
      return {};
    }
  }
};
</script>

<style lang="scss" scoped>
.intro-container{
  display: flex;
  flex-direction: row;
  margin-bottom: 25px;
}
.container-left {
  margin-right: 100px;
}
.img-profile {
  margin-bottom: 20px;
  max-width: 450px;
}
.pre-line {
  white-space: pre-wrap;
}
.btn-darkblue {
  min-width: 200px;
  color: rgb(0, 0, 0);
  border-radius: 10px;
  margin: 10px 5px;
  animation: fade 1.5s;
}
.inline {
  display: row;
}
.row-center{
  align-items: center;
}
.vue-previewer-container {
  padding-right: 20px;
  animation: size 0.5s;
}
.banner-page {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
.btn-container {
  display: flex;
  flex-direction: row;
  animation: fade 1.5s;
  flex-wrap: wrap;
}
a {
  text-decoration: none;
}
table {
  width: 100%;
}
@media (max-width: 450px) {
  .column-when-450 {
    flex-direction: column;
  }
}
@media (max-width: 900px) {
  .intro-container {
    flex-direction: column;
  }
  .vue-previewer-container{
    padding-right: 0px;
  }
}
@media (max-width: 1024px) {
  .container-left {
    margin-right: 0px;
  }
}

// popup
.popup-container {
  // display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1040; /* Sit on top */
  left: 0;
  top: 0;
  width: 100vw; /* Full width */
  height: 100vh; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
  animation: opa 0.3s;
}

/* Modal Content/Box */
.popup-content {
  background-color: #fefefe;
  margin: 60px auto auto; /* 15% from the top and centered */
  padding: 20px;
  border: 1px solid #888;
  width: 80%; /* Could be more or less, depending on screen size */
  animation: size 0.3s;
}

.close-container {
  justify-content: flex-end;
  align-items: center;
  display: flex;
  margin-bottom: 5px;
  margin-right: -8px;
  margin-top: -16px;
  font-size: 30px;
}


@keyframes opa {
  from {opacity: 0;}
  to {opacity: 1;}
}
</style>
<style lang="scss">
/* vue-previewer  */
.pre-container {
  z-index: 2000 !important;
}
.list__img {
  box-sizing: border-box;
  margin: 0px !important;
  img {
    width: 126px;
    margin: 10px 10px;
  }
}
.list__img:first-of-type {
  display: block;
  margin-top: 0px !important;
  img {
    width: 420px;
    height: 315px;
    margin-top: 0px;
  }
}

@media (max-width: 900px) {
  .list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
  .list__img:first-of-type {
    width: 100%;
    img {
      display: block;
      width: 450px;
      margin-left: auto !important;
      margin-right: auto !important;
    }
  }
}
@media (max-width: 450px) {
  .list__img:first-of-type {
    width: 100%;
    img {
      display: block;
      width: 100%;
      height: auto;
      margin-left: auto !important;
      margin-right: auto !important;
    }
  }
}
</style>